import { ColorScheme, getColor } from '@webapp/common/lib/ui';

export enum WidgetPosition {
    CENTER = 'CENTER',

    TOP_LEFT = 'TOP_LEFT',
    TOP_MIDDLE = 'TOP_MIDDLE',
    TOP_RIGHT = 'TOP_RIGHT',

    BOTTOM_LEFT = 'BOTTOM_LEFT',
    BOTTOM_MIDDLE = 'BOTTOM_MIDDLE',
    BOTTOM_RIGHT = 'BOTTOM_RIGHT',

    LEFT_TOP = 'LEFT_TOP',
    LEFT_MIDDLE = 'LEFT_MIDDLE',
    LEFT_BOTTOM = 'LEFT_BOTTOM',

    RIGHT_TOP = 'RIGHT_TOP',
    RIGHT_MIDDLE = 'RIGHT_MIDDLE',
    RIGHT_BOTTOM = 'RIGHT_BOTTOM',
}

export const openedPositionOptions = [
    {
        label: 'по центру',
        value: WidgetPosition.CENTER,
    },
    {
        label: 'по центру вверху',
        value: WidgetPosition.TOP_MIDDLE,
    },
    {
        label: 'по центру внизу',
        value: WidgetPosition.BOTTOM_MIDDLE,
    },
    {
        label: 'слева по центру',
        value: WidgetPosition.LEFT_MIDDLE,
    },
    {
        label: 'слева вверху',
        value: WidgetPosition.LEFT_TOP,
    },
    {
        label: 'слева внизу',
        value: WidgetPosition.LEFT_BOTTOM,
    },
    {
        label: 'справа по центру',
        value: WidgetPosition.RIGHT_MIDDLE,
    },
    {
        label: 'справа вверху',
        value: WidgetPosition.RIGHT_TOP,
    },
    {
        label: 'справа внизу',
        value: WidgetPosition.RIGHT_BOTTOM,
    },
];

export interface Widget {
    url: string;
    enableLogo: boolean;
    position: WidgetPosition;
    text: string;
    textBold: boolean;
    textItalic: boolean;
    textFontFamily: string;
    textBackgroundColor: string;
    textColor: ColorScheme;
    activeInvite: boolean;
    inviteTimer: number;
    cancelReinvite: boolean;
    button1Text: string;
    button2Text: string;
    buttonColor: string;
    buttonTextColor: ColorScheme;
    widgetType: number;
    mobileDisplay: number;
    radius: number;
    width: number;
    height: number;
    colorType: number;
    feedback: string;
    widgetColor: string;
    widgetColor2: string;
    widgetColor3: string;
    borderColor: string;
    opened_position: string;
    popup_opened_position: string;
    logo: string;
    opened_width: number;
    opened_height: number;
    opened_auto_height: boolean;
    opened_radius: number;
    popup_opened_width: number;
    popup_opened_height: number;
    popup_opened_radius: number;
}

export const initialWidget: Readonly<Widget> = {
    url: '',
    enableLogo: true,
    position: WidgetPosition.RIGHT_BOTTOM,
    text: 'Поделитесь мнением',
    textBold: false,
    textItalic: false,
    textFontFamily: 'Arial',
    textBackgroundColor: getColor('blue'),
    textColor: ColorScheme.LIGHT,
    activeInvite: true,
    inviteTimer: 10,
    cancelReinvite: false,
    button1Text: 'Напомнить позже',
    button2Text: 'Больше не показывать',
    buttonColor: getColor('blue'),
    buttonTextColor: ColorScheme.LIGHT,
    widgetType: 1,
    mobileDisplay: 1,
    colorType: 0,
    opened_auto_height: true,
    width: 130,
    height: 40,
    radius: 10,
    feedback: '',
    logo: '',
    borderColor: getColor('blue-border'),
    widgetColor: getColor('blue'),
    widgetColor2: getColor('blue'),
    widgetColor3: getColor('blue'),
    opened_position: WidgetPosition.RIGHT_BOTTOM,
    popup_opened_position: WidgetPosition.RIGHT_BOTTOM,
    opened_width: 50,
    opened_height: 50,
    opened_radius: 4,
    popup_opened_width: 50,
    popup_opened_height: 50,
    popup_opened_radius: 4,
};
